// avoid scrolling if inside slideshow
document.addEventListener('pointerdown', e => {
  if (e.target.closest('.video-controls')) {
    e.stopPropagation();
  }
}, true);

//disable volume if video has no audio
document.querySelectorAll('.custom-video video').forEach(video => {
  // Use 'canplay' to ensure the browser is ready to play/decode
  video.addEventListener('canplay', () => {
    const container = video.closest('.custom-video');
    if (!container) return;

    const muteButton = container.querySelector('.video-mute-toggle');
    
    const checkAudio = () => {
      let hasAudio = false;

      // 1. Check Safari/IE
      if (video.audioTracks && video.audioTracks.length > 0) {
        hasAudio = true;
      } 
      // 2. Check Firefox
      else if (video.mozHasAudio !== undefined) {
        hasAudio = video.mozHasAudio;
      } 
      // 3. Check Chrome/Edge
      else if (video.webkitAudioDecodedByteCount !== undefined) {
        hasAudio = video.webkitAudioDecodedByteCount > 0;
      }

      if (hasAudio) {
        container.classList.remove('video-no-audio');
        if (muteButton) muteButton.classList.remove('disabled');
      } else {
        container.classList.add('video-no-audio');
        video.muted = true;
        if (muteButton) muteButton.classList.add('muted');
      }
    };

    // Chrome specific: if decoded count is 0, wait a split second and check again
    if (video.webkitAudioDecodedByteCount === 0) {
      setTimeout(checkAudio, 500); 
    } else {
      checkAudio();
    }
  }, { once: true }); // Prevent event firing multiple times
});


// listen for click event
document.addEventListener('click', e => {

  const playButton = e.target.closest('.video-play-toggle');
  const muteButton = e.target.closest('.video-mute-toggle');

  const container = e.target.closest('.custom-video');
  if (!container) return;

  const video = container.querySelector('video');
  if (!video) return;

  const volumeSlider = container.querySelector('.video-volume');

  if (playButton) {

    if (video.paused) {
      video.play();
      playButton.classList.remove('paused');
    } else {
      video.pause();
      playButton.classList.add('paused');
    }

  }

  if (muteButton) {

    if (container.classList.contains('video-no-audio')) return;

    const wasMuted = video.muted;
    video.muted = !video.muted;

    if (wasMuted && volumeSlider && Number(volumeSlider.value) === 0) {
      const defaultVolume = 0.2;
      video.volume = defaultVolume;
      volumeSlider.value = defaultVolume;

    }

    muteButton.classList.toggle('muted', video.muted);

  }

});


// volume slider logic
document.addEventListener('input', e => {

  if (!e.target.classList.contains('video-volume')) return;

  const container = e.target.closest('.custom-video');

  if (container.classList.contains('video-no-audio')) return;

  const video = container.querySelector('video');
  const muteButton = container.querySelector('.video-mute-toggle');
  const volume = Number(e.target.value);
  video.volume = volume;

  if (volume > 0) {
    video.muted = false;
    muteButton.classList.remove('muted');
  } else {
    video.muted = true;
    muteButton.classList.add('muted');
  }

});
